import styled from 'styled-components';
import { Col as Col_, Row as Row_ } from 'reactstrap';

export const Col = styled(Col_)`
    ${ ({ maxwidth }) => maxwidth ? `max-width: ${ maxwidth };` : '' }
`;

export const Message = styled.div`
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: 16px;
`;

export const Row = styled(Row_)`

`;
